import request from '../utils/require'
import require_nocredentials from '../utils/require_nocredentials'
export function getAccessToken() {
  return request({
    url: '/User_upload/baidu_access_token',
    method: 'GET'
  })
}
export function getAccessTokenSecond() {
  return request({
    url: '/User_upload/baidu_access_token_limit',
    method: 'GET'
  })
}
// export function aiBaidu(access_token, content) {
//   return require_nocredentials({
//     baseURL: 'https://idupload.fastgo.com.au/baiduApi/',
//     url: 'rest/2.0/ocr/v1/idcard?access_token=' + access_token,
//     method: 'post',
//     data: content
//   })
// }
export function aiBaidu(content) {
  return require_nocredentials({
    baseURL: 'https://idupload.fastgo.com.au/',
    url: 'idcard/receive_idcards',
    method: 'post',
    data: content
  })
}
export function idCardSave(content) {
  return require_nocredentials({
    baseURL: 'https://idupload.fastgo.com.au/',
    url: 'idcard/save_idcards',
    method: 'post',
    data: content
  })
}
export function baidushibie( content) {
  return request({
    url: '/user_upload/baiducard',
    method: 'post',
    data: content
  })
}


export function getOssParam() {
  return request({
    url: '/User_upload/web_upload_to_oss_new_version',
    method: 'get'
  })
}

export function sendError() {
  return request({
    url: '/dev_assist/notice_manager_limit_baiduaccount',
    method: 'get'
  })
}
export function getCOSparam(content) {
  return request({
    url: '/User_upload/web_upload_to_oss_tx_new_version',
    method: 'post',
    data: content
  })
}




// WEBPACK FOOTER //
// ./src/services/upload.js